import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Icon1 from '../../assets/img/logo/favicon.png';
import image1 from '../../assets/img/find.jpeg'
import line from '../../assets/img/line.png'
import ghanaFlag from '../../assets/img/flag/ghana_flag.png'
import senegalFlag from '../../assets/img/flag/senegal_flag.png'
import nigeriaFlag from '../../assets/img/flag/nigeria_flag.png'
import kenyaFlag from '../../assets/img/flag/kenya_flag.png'
import egyptFlag from '../../assets/img/flag/egypt_flag.png'
import malawiFlag from '../../assets/img/flag/malawi_flag.png'
import rwandaFlag from '../../assets/img/flag/rwanda_flag.png'
import southAfricaFlag from '../../assets/img/flag/south-africa_flag.png'
import empowerImg from '../../assets/img/empower.png';
import CurrencyConverter from '../../components/CurrencyConversion/CurrencyConverter';
import Slider from "react-slick";
import { Helmet } from "react-helmet-async";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Pricing() {
  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
  const flags = {
    NGN: nigeriaFlag,
    GHS: ghanaFlag,
    SEN: senegalFlag,
    KEN: kenyaFlag,
    EGY: egyptFlag,
    MAL: malawiFlag,
    RWA: rwandaFlag,
    SAF: southAfricaFlag,
  };

  const exchangeRates = {
    NGN: 1,
    GHS: 0.1,
    SEN: 0.2,
    KEN: 0.3,
    EGY: 0.4,
    MAL: 0.5,
    RWA: 0.6,
    SAF: 0.7,
  };


  const [sendAmount, setSendAmount] = useState(30000);
  const [sendCurrency, setSendCurrency] = useState('NGN');
  const [receiveCurrency, setReceiveCurrency] = useState('GHS');
  const [receiveAmount, setReceiveAmount] = useState(0);

  // Exchange rate (in real app, this would come from an API)
  const exchangeRate = 0.1; // NGN 1 = GHS 0.1
  const fee = 1600.32;

  useEffect(() => {
    const converted = sendAmount * exchangeRates[receiveCurrency];
    setReceiveAmount(converted.toFixed(2));
  }, [sendAmount, receiveCurrency]);


  const MoneyFeatures = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const features = [
    {
      icon: "fa-solid fa-arrow-right-to-bracket",
      title: "Receive and Add Money",
      description: "Get paid into and/or add money into your Cardplot account"
    },
    {
      icon: "fa-solid fa-icons",
      title: "Convert Money in your Account",
      description: "Hold and convert over 10+ African currencies in your cardplot account"
    },
    {
      icon: "fa-solid fa-credit-card",
      title: "Virtual Card",
      description: "Create and manage virtual cards for your transactions"
    }
  ];

  const Prizing = [
    {
      name: "Registering with Cardplot",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Registering with Cardplot",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Registering with Cardplot",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Registering with Cardplot",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Applies to transactions that include topping up e-wallets and other accounts in certain currencies",
      swapFee: "Free",
      intlPayout: "Free",
    },
    {
      name: "Registering with Cardplot",
      swapFee: "Free",
      intlPayout: "Free",
    },
    
  ];
  return (
    <>

      <Helmet>
        <title>Pricing | Cardplot</title>
        <meta name="description" content="Discover the benefits of Cardplot's payment service. Instantly transfer money to anyone with low fees." />
      </Helmet>
      <section className='breadcrumb__section bg-overlay'>
        <div className="container">
          <div className='row'>
            <div className='col-md-12'>
              <div className="breadcrumb__title__head">
                <ol className="breadcrumb">
                  <li className="active"><img src={Icon1} style={{ width: '25px', height: '25px' }} alt="" /></li>
                </ol>
                <h2 className='breadcrumb__title'> PRICING </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h3 className='breadcrumb__text__head break__text text-capitalize'> Why pay more else where? </h3>
                <p className='breadcrumb__text__content'>
                  Our clear and transparent process ensures you stay informed every step of the way. Fees are based on the transfer amount, the currency being sent, and the chosen payment method no surprises, just straightforward transactions.
                </p>
              </div>
              <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
                <Link to='/contact' className='btn btn__outline_primary text__dark'>Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className='convert__currency__section ' style={{ background: '#13053a' }}>
        <div className='container'>
          <div className="row  justify-content-center align-items-center">
            <div className='col-12 col-md-6 my-3'>
              <div className="convert__currency_content">
                <h2 className="convert__currency__title text-white">Convert your local currency to any other African currency!</h2>
                <p className="convert__currency__subtitle text-white">Exchange your local currency in-app, then feel free to transact with it however you please with great exchange rates and low fees.</p>
              </div>
            </div>
            <div className='col-12 col-md-6 my-3'>
              <CurrencyConverter />
              {/* <div className="card shadow-sm rounded-4 p-4">
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex justify-content-between">
                      <h5 className="convert__currency__title">You send exactly:</h5>
                      <h5 className="convert__currency__subtitle">Recipient gets:</h5>
                    </div>

                    <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                      <div className="flex-grow-1">
                        <div className="border rounded-4 p-3 d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-2">
                            <div className="currency-flag">
                              <img src={flags[sendCurrency]} alt={sendCurrency} width="24" height="24" />
                            </div>
                            <select
                              className="form-select border-0"
                              value={sendCurrency}
                              onChange={(e) => setSendCurrency(e.target.value)}
                            >
                              {Object.keys(flags).map((currency) => (
                                <option key={currency} value={currency}>{currency}</option>
                              ))}
                            </select>
                          </div>
                          <input
                            type="number"
                            className="form-control border-0 text-end fw-bold fs-4"
                            value={sendAmount}
                            onChange={(e) => setSendAmount(e.target.value)}
                            style={{ maxWidth: '150px' }}
                          />
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <button className="btn btn-primary rounded-circle">
                          <i className="bi bi-arrow-left-right"></i>
                        </button>
                      </div>

                      <div className="flex-grow-1">
                        <div className="border rounded-4 p-3 d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-2">
                            <div className="currency-flag">
                              <img src={flags[receiveCurrency]} alt={receiveCurrency} width="24" height="24" />
                            </div>
                            <select
                              className="form-select border-0"
                              value={receiveCurrency}
                              onChange={(e) => setReceiveCurrency(e.target.value)}
                            >
                              {Object.keys(flags).map((currency) => (
                                <option key={currency} value={currency}>{currency}</option>
                              ))}
                            </select>
                          </div>
                          <div className="fw-bold fs-4">{receiveAmount}</div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="col-12 pt-3">
                    <div className="d-flex justify-content-between py-1">
                      <span className="convert__currency__rate__title">Exchange rate:</span>
                      <span className='convert__currency__rate__price'>NGN 1.00 = GHS {exchangeRate}</span>
                    </div>
                    <div className="d-flex justify-content-between py-1">
                      <span className="convert__currency__rate__title">Our fee:</span>
                      <span className='convert__currency__rate__price'>FREE</span>
                    </div>
                    <div className="d-flex justify-content-between py-1">
                      <span className="convert__currency__rate__title">Total Fees:</span>
                      <span className='convert__currency__rate__price'>NGN {fee}</span>
                    </div>
                    <div className="d-flex justify-content-between py-1">
                      <span className="convert__currency__rate__title">Total Amount we'll convert:</span>
                      <span className='convert__currency__rate__price'>NGN {(parseFloat(sendAmount) + fee).toFixed(2)}</span>
                    </div>

                    <button type='submit' className="btn btn-primary w-100 py-3 mt-4 rounded-4">
                      Send Money
                    </button>

                    <p className="convert__currency_small  pt-1">
                      Exchange rates are dynamic. Always remember to check the applicable rate in-app before carrying out your exchange
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section className="money-features py-5">
        <div className="container">
          <div className="row feature-card-wrapper">
            {features.map((feature, index) => (
              <div className="col-md-4 col-sm-12" key={index}>
                <div className="feature-card">
                  <div className="feature__content__head mb-3">
                    <div className="feature-icon me-3 my-lg-0 my-2">
                      <i className={`${feature.icon} `}></i>
                    </div>
                    <div className='feature-content'>
                      <h3 className="feature-title">{feature.title}</h3>
                      <p className="feature-description">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section className='pricing__section'>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className='pricing__title'>Price Comparison</h2>
            </div>
          </div>
          <div className=" pricing__comparison__box">
            <div className="table-responsive">
              <table  className="">
                <thead className="table-dark">
                  <tr>
                    <th></th>
                    <th>
                      <button className='pricing__comparison__box__item__header__button'>Personal</button>
                    </th>
                    <th>
                      <button className='pricing__comparison__box__item__header__button'>Business</button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Prizing.map((currency, index) => (
                    <tr key={index}>
                      <td className="d-flex align-items-center gap-2">
                        {currency.name}
                      </td>
                      <td>{currency.swapFee}</td>
                      <td>
                        {currency.intlPayout }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section className='empower_your_trade'>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 mb-lg-0 mb-5">
              <div className="empower__title">
                <h2>Ready to simplify your payments?</h2>
                <p>Simplify Your Exchange, Empower Your Trade</p>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                  <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="empower__img">
                <img src={empowerImg} className='img-fluid' alt="empower" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Pricing